import { Button } from "@/components/ui/button";

export const GoogleButton = ({ label = "Lanjutkan dengan Google" }) => {
  const start = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <Button type="button" variant="outline" onClick={start} data-testid="google-login-button" className="h-11 w-full rounded-xl border-stone-300 font-semibold">
      <svg className="mr-2 h-4 w-4" viewBox="0 0 24 24" aria-hidden="true">
        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z" />
        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z" />
        <path fill="#FBBC05" d="M5.84 14.09A6.6 6.6 0 0 1 5.5 12c0-.73.13-1.43.34-2.09V7.07H2.18A11 11 0 0 0 1 12c0 1.78.43 3.45 1.18 4.93l3.66-2.84z" />
        <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1A11 11 0 0 0 2.18 7.07l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z" />
      </svg>
      {label}
    </Button>
  );
};

export const AuthShell = ({ title, subtitle, children }) => (
  <div className="container-page grid min-h-[calc(100vh-4rem)] items-start gap-12 py-12 lg:grid-cols-[1fr_1.1fr] lg:py-20">
    <div className="hidden lg:block">
      <div className="relative overflow-hidden rounded-3xl">
        <img
          src="https://static.prod-images.emergentagent.com/jobs/e721ece0-0dd3-437f-9af4-b69114055a15/images/d2f1001f7fdccbd990e40d050839e6294ee80822a2fd00c82a0cc205a6e041f6.jpeg"
          alt="Teknisi Tuntas"
          className="h-[560px] w-full object-cover"
        />
        <div className="absolute inset-x-6 bottom-6 rounded-2xl bg-white/85 p-5 backdrop-blur-md">
          <p className="text-sm font-semibold text-stone-900">Hingga 3 penawaran untuk setiap permintaan Anda.</p>
          <p className="mt-1 text-xs text-stone-500">Gratis untuk pelanggan · Bandingkan harga, lalu pilih yang paling pas.</p>
        </div>
      </div>
    </div>
    <div className="mx-auto w-full max-w-md animate-fade-up">
      <h1 className="text-3xl font-bold tracking-tight text-stone-900">{title}</h1>
      <p className="mt-2 text-stone-500">{subtitle}</p>
      <div className="mt-8">{children}</div>
    </div>
  </div>
);
